import Vue from 'vue'
import Router, { Route } from 'vue-router'
import { Store } from 'vuex'

export default abstract class LocalVue extends Vue {
  public $route: Route

  public $router: Router

  /**
   * @NOTE add a legit, shared, store interface in the future.
   * `any` is not an interface and doesn't provide useful reflection
   */
  public $store: Store<any>
}
